import { useQuery } from '@tanstack/react-query';
import { apiClinicOnboardingValidateToken } from 'lib/api/firebase/apis/apis';
import { queryKeyFactory } from 'lib/utils/queryKeyFactory';

export function useValidateOnboardingTokenQuery(token: string | null) {
  return useQuery({
    queryKey: queryKeyFactory.clinic.onboarding.validate(token ?? ''),
    queryFn: async () => apiClinicOnboardingValidateToken({ token: token ?? '' }),
    retry: false
  });
}
